<template>
  <layout-apply-cancel @cancel="cancel" @apply="applyClick">
  </layout-apply-cancel>
</template>

<script>
import LayoutApplyCancel from 'AssetEditor/layouts/LayoutApplyCancel.vue';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapActions } from 'vuex';

export default {
  components: {
    LayoutApplyCancel,
  },

  methods: {
    ...mapActions('assetEditor', ['changeCurrentPage']),

    cancel: function () {
      this.changeCurrentPage('preview');
    },
    /**
     * Emit apply event
     * caught by assetEditorVue's active child component
     */
    applyClick: function () {
      bus.$emit('apply-click');
      this.changeCurrentPage('preview');
    },
  },
};
</script>
